import React, { useEffect } from 'react'
import { useTranslation } from "react-i18next";
import styles from '../../Components/Terms/Terms.module.css';  // Import CSS Module styles
import Terms from '../../Components/Terms/Terms';
import { useDispatch } from 'react-redux';
import { getConditions } from '../../redux/Slices/users/thunk';


function TermsPage() {
      const { t, i18n } = useTranslation();
      const dispatch = useDispatch();
      useEffect(()=>{
        dispatch(getConditions())
      },[])
  
  return (
    <div className='flex-grow-1'>
    <div className={styles.loginContainer}>
    <div className={styles.loginHeader}>{t("termsAndConditions")}</div>

      </div>
<Terms />
    </div>
  )
}
export default TermsPage;
